module.exports = __webpack_public_path__ + "img/step4img.e228374b.png";